<section class="comment-viewer-container">
  <cdk-virtual-scroll-viewport class="virtual-viewport" style="height: 100%;">
    <ul role="list" class="comment-list">
      <li
        role="listitem"
        *cdkVirtualFor="let comment of commentListService.comments$ | async; trackBy: 'comment_id'|trackByProp; templateCacheSize: 25;"
        [attr.data-comment-id]="comment.comment_id || comment.temp_id"
        data-cy="feedback-item"
        class="comment-item"
				[ngClass]="{
					'is-active': activeCommentIds.includes(comment.comment_id),
					'is-reply': comment.parent_id !== null,
					'end-note': comment.time === null,
					'is-selected': selectedComment?.comment_id === comment.comment_id,
					'unviewed': !comment.viewed_by_me
				}"
        >
        @if (comment.time === null && isFirstEndNote(comment) | async) {
          <span
            class="end-note-divider"
          ></span>
        }
        <button
          [tabindex]="editingCommentIds.includes(comment.comment_id) ? -1 : 0"
          class="comment-button"
          data-cy="feedback-item-cover"
          [attr.aria-label]="getAriaLabel(comment)"
          [disabled]="isTimeCodeClickDisabled()"
          (click)="onCommentClick(comment)"
          >
          @if (shouldDisplayTimeCode(comment)) {
            <span
              class="time-container"
              data-cy="feedback-badge"
              [tabindex]="editingCommentIds.includes(comment.comment_id) ? 0 : -1"
						(click)="
							editingCommentIds.includes(comment.comment_id)
								? editTime($event, comment)
								: null
						"
						(keyup.enter)="
							editingCommentIds.includes(comment.comment_id)
								? editTime($event, comment)
								: null
						"
						[matTooltip]="
							editingCommentIds.includes(comment.comment_id)
								? ('feedback-session-feedback-tree-comment_edit-time-code'
								  | translate)
								: ('time-code_disabled_video_seeking' | translate)
						"
						[matTooltipDisabled]="
							!editingCommentIds.includes(comment.comment_id) ||
							isTimeCodeClickDisabled()
						"
						[ngClass]="{
							editable: editingCommentIds.includes(comment.comment_id)
						}"
              >
              <span class="time-text">
                {{ comment.time | formatTime }}
              </span>
            </span>
          }
          @if (comment.parent_id !== null) {
            <span class="reply-indicator">
              <i class="ficon-reply"></i>
            </span>
          }
          <span class="comment-details">
            <span class="comment-header">
              <span class="commenter">
                @if (!isSyncEventType(comment)) {
                  {{ comment.first_name }} {{ comment.last_name }}
                  @if (comment.was_ai_generated && featureFlagService.isAvailable('ECHOREFLECT_REBRAND')) {
                    <i class="ficon-sparkles-solid" aria-hidden="true"></i>
                  }
                } @else {
                  <span class="ficon-app-presentation slide-deck-icon"></span><strong class="feedback-item-name" data-cy="feedback-item-name">{{('feedback-session-feedback-tree-comment_slide-time' | translate) + ' ' + comment.resource[0].item.time}}</strong>
                }
              </span>
              @if (!comment.viewed_by_me) {
                <span
                  [matTooltip]="(comment.directed_at_me ? 'feedback-item_directed-at-me' : 'feedback-item_unviewed') | translate"
                  class="unviewed-dot"
                  [ngClass]="{ 'not-directed-at-me': !comment.directed_at_me }">
                </span>
              }
              <span class="comment-timestamp">
                {{ comment.created_at | formatDate: 'MMM D, YYYY h:mmA' }}
              </span>
            </span>
            @if (
              comment.markers?.length > 0 &&
              !editingCommentIds.includes(comment.comment_id)
              ) {
              <span
                >
                <marker-display
                  [markers]="comment.markers"
                  [aiStyle]="comment.was_ai_generated"
                  [withName]="true"
                  >
                </marker-display>
              </span>
            }
            @if (!editingCommentIds.includes(comment.comment_id)) {
              <span
                class="comment-text"
                data-cy="feedback-item-text"
                [innerHTML]="comment.text | sanitize"
                >
              </span>
            }
            @if (comment.updated_by) {
              <span class="ai-edited-by" translate="feedback-session-feedback-tree-comment_ai-edited-by" [translateParams]="{ updated_by: comment.updated_by }"></span>
            }
            @if (
              comment.media?.length > 0 &&
              !editingCommentIds.includes(comment.comment_id)
              ) {
              <span
                class="all-media-container"
                >
                @for (media of comment.media; track media.media_id) {
                  <div class="media-container">
                    @if (mayEdit(comment)) {
                      <div class="btn-bar media-item-toolbar" [ngClass]="{ 'visible': selectedComment?.comment_id === comment.comment_id }">
                        <button
                          type="button"
                          (click)="setSelectedComment(comment, $event)"
                          [matMenuTriggerFor]="mediaMenu"
                          class="btn-none menu-btn media-menu-btn"
                          [attr.aria-label]="'session-list-item_view-options' | translate"
                          >
                          <i class="ficon-app-dots-vertical"></i>
                        </button>
                        <mat-menu #mediaMenu="matMenu" class="action-menu">
                          <button
                            mat-menu-item
                            class="remove-btn"
                            (click)="deleteMediaResource(comment, media.item)"
                            >
                            {{ "common_delete" | translate }}
                          </button>
                          @if (media.item.filename && media.item.media_status === 'ready') {
                            <button
                              mat-menu-item
                              class="download-btn"
                              (click)="download($event, media.item)"
                              >
                              {{ "common_download" | translate }}
                            </button>
                          }
                          @if (canAddToLibrary(media.item)) {
                            <button
                              mat-menu-item
                              class="add-to-library-btn"
                              (click)="addToLibrary(media.item)"
                              >
                              {{ "feedback-session-feedback-tree-comment_add-to-library" | translate }}
                            </button>
                          }
                        </mat-menu>
                      </div>
                    }
                    <media-preview
                      (click)="$event.stopPropagation()"
                      class="media-item-preview"
                      [ngClass]="{ audio: media.item.media_type === 'audio' }"
                      [media]="media.item"
									[previewerId]="
										'comment-media-' + media.comment_id + '-' + media.resource_id
									"
                      [initialOffset]="media.item.time"
                      [collapseAudio]="media.item.media_type === 'audio'"
                      [minimizedControls]="true"
                      [allowDownload]="media.item.filename"
                      [options]="mediaPreviewOptions"
                      >
                    </media-preview>
                    @if (media.item.title) {
                      <span class="media-item-title">{{
                        media.item.title
                      }}</span>
                    }
                  </div>
                }
              </span>
            }
            @if (
              comment.reactions?.length &&
              !editingCommentIds.includes(comment.comment_id)
              ) {
              <ngx-comment-reactions
                class="display-mode"
                [mode]="commentReactionModes.DISPLAY"
                [comment]="comment"
                >
              </ngx-comment-reactions>
            }
          </span>
        </button>

        @if (!ltiReadOnly) {
          <ngx-comment-menu
            class="visible-when-active"
            (setSelectedComment)="setSelectedComment(comment)"
            [mode]="commentReactionModes.DISPLAY"
            [feedbackItem]="comment"
            [hideCommentReply]="hideCommentReply"
            (edit)="edit($event)"
            (addAiAssistant)="addAiAssistant.emit()"
            >
          </ngx-comment-menu>
        }

        @if (editingCommentTime.includes(comment.comment_id)) {
          <feedback-time-editor
            [duration]="totalDuration"
            [comment]="comment"
            (onSave)="keepTimeEdit($event, comment)"
            (onClose)="cancelTimeEdit(comment)"
            >
          </feedback-time-editor>
        }

        @if (editingCommentIds.includes(comment.comment_id) && isSyncEventType(comment)) {
          <span class="slide-preview-container">
            <media-preview
              class="slide-preview"
              [media]="session.source_media"
              [previewerId]="'comment-media-' + comment.comment_id + '-' + comment.resource[0].resource_id"
              [initialOffset]="comment.resource[0].item.time"
              [options]="mediaPreviewOptions">
            </media-preview>
          </span>
        }

        @if (showFeedbackCreator(comment)) {
          <ngx-feedback-creator
            [session]="session"
            [playerSync]="playerSync"
            [tagsList]="tags"
            [userGroup]="group"
            [oldComment]="comment"
            [mode]="'edit'"
            [viewFrom]="viewFrom"
            (onClose)="cancelEdit(comment)"
          ></ngx-feedback-creator>
        }
      </li>
    </ul>
  </cdk-virtual-scroll-viewport>
</section>
